import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Container, Grid, Typography } from '@material-ui/core';

import { IMPRINT_PATH, PRIVACY_POLICY_PATH, CONTACT_PATH } from '../routes';

import { companyContactDetails, externalLinks } from '../config.json';

import IconTwitter from '../assets/icon-twitter.svg';
import IconLinkedin from '../assets/icon-linkedin.svg';
import IconXing from '../assets/icon-xing.svg';
import IconContact from '../assets/icon-contact.svg';
import BtnOutline from './common/BtnOutline';

const Root = styled.footer`
	margin-top: 40px;
	padding: 60px 0;
	background-color: ${(props) => props.theme.palette.blocks.footer.background};
	color: ${(props) => props.theme.palette.blocks.footer.color};
	border-top: 10px solid ${(props) => props.theme.palette.blocks.footer.borderColor};

	a {
		color: ${(props) => props.theme.palette.blocks.footer.linkColor};
	}

	h6 {
		margin: 40px 0 10px 0;
		font-size: 16px;
		font-weight: bold;
	}

	.footer__social {
		a {
			display: inline-block;

			&:not(:first-child) {
				margin-left: 10px;
			}
		}

		img {
			width: 40px;
		}
	}

	.footer__copyright {
		margin-top: 40px;
	}

	.footer__btn {
		margin-top: 40px;
	}
`;

const Footer = () => (
	<Root>
		<Container maxWidth="lg">
			<div className="footer__social">
				<a href={externalLinks.twitter} target="_blank" rel="noopener noreferrer">
					<img src={IconTwitter} alt="TwitterIcon" />
				</a>
				<a
					href={externalLinks.linkedIn}
					target="_blank"
					rel="noopener noreferrer"
				>
					<img src={IconLinkedin} alt="LinkedInIcon" />
				</a>
				<a href={externalLinks.xing} target="_blank" rel="noopener noreferrer">
					<img src={IconXing} alt="XingIcon" />
				</a>
				<Link to={CONTACT_PATH}>
					<img src={IconContact} alt="ContactIcon" />
				</Link>
			</div>
			<Grid container justify="space-between">
				<Grid item xs={8}>
					<Typography variant="h6">Kontakt</Typography>
					<Typography variant="body2">
						<strong>Tel.:</strong> {companyContactDetails.phone}
					</Typography>
					<Typography variant="body2">
						<strong>E-Mail:</strong> {companyContactDetails.email}
					</Typography>
					<Typography variant="body2">
						<strong>Besucheradresse:</strong>{' '}
						{companyContactDetails.visitorAdress}
					</Typography>
					<Typography variant="body2">
						<strong>Postadresse und Sitz der Gesellschaft:</strong>{' '}
						{companyContactDetails.postAdress}
					</Typography>
					<Typography variant="h6">Rechtliches</Typography>
					<Link to={IMPRINT_PATH}>Impressum</Link>
					{' / '}
					<Link to={PRIVACY_POLICY_PATH}>Datenschutz</Link>
					<div className="footer__copyright">
						<Typography variant="body2">
							Ein Unternehmen der <strong>EWE AG</strong>
						</Typography>
						<Typography variant="body2">
							© {new Date().getFullYear()} be.storaged GmbH
						</Typography>
					</div>
				</Grid>
				<Grid item xs={4}>
					<Typography variant="h6">Partner werden</Typography>
					<Typography variant="body2">
						Erweitern Sie Ihr Portfolio um die Möglichkeit, Batteriesysteme
						für Ihre Kunden zu projektieren.
					</Typography>
					<div className="footer__btn">
						<BtnOutline
							href={externalLinks.becomePartner}
							target="_blank"
							rel="noopener noreferrer"
						>
							Weitere Informationen
						</BtnOutline>
					</div>
				</Grid>
			</Grid>
		</Container>
	</Root>
);

export default Footer;
